/**
 * External dependencies
 */
import { remove, get } from "lodash";

/**
 * Internal dependencies
 */
import { editReport } from "state/reports/actions";
import { getEditedReport } from "state/reports/selectors";
import { getBuilderReportId } from "state/ui/report-builder/selectors";

export default (index) => {
  return (dispatch, getState) => {
    let state = getState();
    let reportId = getBuilderReportId(state);
    let report = getEditedReport(state, reportId);

    if (!report) {
      return false;
    }

    let filters = get(report, "config.filters", []);
    filters = remove([...filters], (m) => m !== filters[index]);

    dispatch(
      editReport(reportId, {
        config: { filters },
      })
    );
  };
};
